export const attendanceToday = () => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit'
}).format(new Date());

export const shiftAttendanceDate = (date, days) => {
  const value = new Date(`${date}T12:00:00Z`);
  value.setUTCDate(value.getUTCDate() + days);
  return value.toISOString().slice(0, 10);
};

export const calendarDays = (month, presentDates, today, joinedDate) => {
  const number = Number(month.slice(5));
  const first = new Date(`${month}-01T12:00:00Z`);
  const last = new Date(first);
  last.setUTCMonth(number, 0);
  const count = last.getUTCDate();
  const present = new Set(presentDates);
  return [
    ...Array.from({ length: first.getUTCDay() }, () => null),
    ...Array.from({ length: count }, (_, index) => {
      const date = `${month}-${String(index + 1).padStart(2, '0')}`;
      const status = date > today ? 'Future' : present.has(date) ? 'Present'
        : joinedDate && date < joinedDate ? 'Not enrolled' : date === today ? 'Pending' : 'Absent';
      return { date, day: index + 1, status };
    })
  ];
};
